import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

export const getPurchaseItems = async ({
  page = 1,
  limit = 20,
  brand,
  categoryId,
  ingredientId,
  ingredientIds,
  isActive,
  signal,
} = {}) => {
  const query = qs({ page, limit, brand, categoryId, ingredientId, ingredientIds: ingredientIds?.join?.(",") || ingredientIds, isActive });
  return httpClient.get(`/stock/purchase-items${query}`, { signal });
};

export const getPurchaseItemCategoryOptions = async ({ signal } = {}) => {
  return httpClient.get("/stock/ingredient-categories/options", { signal });
};

export const deletePurchaseItem = async (purchaseItemId) => {
  if (!purchaseItemId) throw new Error("El ID del ítem de compra es requerido");
  return httpClient.delete(`/stock/purchase-items/${purchaseItemId}`);
};

export const createPurchaseItem = async (data) => {
  return httpClient.post("/stock/purchase-items", data);
};

export const patchPurchaseItem = async (purchaseItemId, data) => {
  if (!purchaseItemId) throw new Error("El ID del ítem de compra es requerido");
  return httpClient.patch(`/stock/purchase-items/${purchaseItemId}`, data);
};

export const savePurchaseItemsBatch = async (rows) => {
  if (!Array.isArray(rows) || rows.length < 1) {
    throw new Error("El lote debe contener al menos una fila");
  }
  return httpClient.post("/stock/purchase-items/batch", { rows });
};
